module.exports = __webpack_public_path__ + "img/Weapon_48.90c0655d.png";